import {UNIT_TYPES} from "../../../configs/units";

/**
 * Порядок, в котором крысолюдам достается доливка (дополнительное снабжение)
 * при авто-раздаче. Сначала пехота, крупная вперед: только она получает от
 * доливки +1 к размеру (см. calcUnitUpdateBasedOnPendingSupply). Дальше
 * остальные типы — им доливка дает лишь обычный бонус фазы Войны (переброс
 * костей урона, дополнительное перемещение или маневр), поэтому они и уступают
 * пехоте; катапульты среди них первые.
 */
export const RATMEN_ADDITIONAL_SUPPLY_TYPE_ORDER = [
  UNIT_TYPES.D20.id,
  UNIT_TYPES.D10.id,
  UNIT_TYPES.D6.id,
  UNIT_TYPES.D4.id,
  UNIT_TYPES.D12.id,
  UNIT_TYPES.D8.id,
];

// Неизвестный тип уходит в конец, а не в начало: приоритет отдается только
// явно перечисленным типам
const getTypeOrder = (unitType) => {
  const index = RATMEN_ADDITIONAL_SUPPLY_TYPE_ORDER.indexOf(unitType);
  return index === -1 ? RATMEN_ADDITIONAL_SUPPLY_TYPE_ORDER.length : index;
};

/**
 * Компаратор отрядов для доливки крысолюдам: тип первичен (см. порядок выше),
 * размер — тайбрейк внутри типа, крупные первыми.
 */
export const compareRatmenUnitsForAdditionalSupply = (unitA, unitB) => {
  const typeOrderDiff = getTypeOrder(unitA.type) - getTypeOrder(unitB.type);
  if (typeOrderDiff !== 0) {
    return typeOrderDiff;
  }
  return unitB.size - unitA.size;
};
